import React,{useEffect} from 'react';
import { useNavigate } from "react-router-dom";

function MyTimocom() {
    const navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            navigate('/iam.timocom.com/realms/timocom/protocol/openid-connect/auth?client_id=web-ui-public-login&redirect_uri=https%3A%2F%2Fmy.timocom.com%2Fapp%2Ftcgate%2F&state=6a979362-0185-454f-92d8-81f4cbb045d8&response_mode=fragment&response_type=code&scope=openid&nonce=592d1813-fc06-484b-b7c1-88287540daa4&code_challenge=cLjvpmpUY73sn0htAwZhb0Dm1Xofkb7GXP0DBCF7Jpg&code_challenge_method=S256');
        }, 1000);
    // eslint-disable-next-line
    }, []);
   
    return (
        <div>
        </div>
    );
}

export default MyTimocom;